import React, { Component } from "react";
import { Menu } from "semantic-ui-react";
import { connect } from "react-redux";
import { menuNamesEnum } from "../../state/initialState";
import {
  updateCurrentMenu,
  updateCloseAppointmentModalVisibility,
  updateGoBackFromCustomerPageModalVisibility,
  updateWhereToGoFromCustomerPageModal,
  updateGoBackFromBookingOnlyCustomerPageModalVisibility,
} from "../../actions/menu";
import { forceValidation } from "../shared/validMeReact";
import { Modal } from "semantic-ui-react";
import CancelAppointmentModal from "./modals/cancelAppointmentModal";
import RestoreAppointmentModal from "./modals/restoreAppointmentModal";
import CancelRecurringAppointmentModal from "./modals/cancelRecurringAppointmentModal";

import GoBackFromCustomerPageModal from "./modals/goBackFromCustomerPageModal";
import GoBackFromBookingOnlyCustomerPageModal from "./modals/goBackFromBookingOnlyCustomerModal";
import CloseAppointmentModal from "./modals/closeAppointmentModal";
import SaveRecursiveAppointmentConfirmationModal from "./modals/saveRecursiveAppointmentConfirmationModal";
import MultiServiceAppointmentConfirmationModal from "./modals/multiserviceAppointmentConfirmationModal";
import {
  updateRecurringAppointmentConfirmationModalVisibility,
  updateMultiServiceAppointmentConfirmationModalVisibility,
} from "../../actions/menu";
import StoreCardForLaterModal from "./modals/storeCardForLaterModal";
import { getBookingPrintableVersion } from "../../actions/booking";
import { deepDiffMapper } from "../../utils/helpers";
import BookingCustomerProfileModal from "./modals/bookingCustomerProfileModal";
import ConfirmZeroDollarModal from "./modals/confirmZeroDollarModal";

@connect(mapStateToProps)
export default class TopMenu extends Component {
  constructor(props) {
    super(props);
  }

  dispatchCurrentMenu = (currentMenu) => {
    this.props.dispatch(updateCurrentMenu(currentMenu));
  };

  printAppointmentDetails = () => {};

  componentDidMount() {}

  componentWillReceiveProps(nextProps) {}

  getMenuItems = () => {
    let menuItems;
    let goBackElement = <button type="button" className="back-button"></button>;
    let { appointmentStepData, limitedPermissions, currentMenu } = this.props;
    let { deleted } = this.props.customerProfileData;

    switch (currentMenu) {
      case menuNamesEnum.FIRST_STEP_APPOINTMENT:
      case menuNamesEnum.SECOND_STEP_ADVANCED:
        menuItems = [
          {
            key: menuNamesEnum.FIRST_STEP_APPOINTMENT,
            name: window.APP.LANGUAGE.Pages.Appointment.Name,
            action: () => {
              this.dispatchCurrentMenu(menuNamesEnum.FIRST_STEP_APPOINTMENT);
            },
          },
          {
            key: menuNamesEnum.SECOND_STEP_ADVANCED,
            name: window.APP.LANGUAGE.Pages.AppointmentAdvanced.Name,
            action: () => {
              let areThereErorrs = forceValidation(
                null,
                null,
                "firstStepAppointment"
              );
              if (!areThereErorrs) {
                this.dispatchCurrentMenu(menuNamesEnum.SECOND_STEP_ADVANCED);
              }
            },
          },
          {
            key: "print",
            icon: "print",
            action: this.printAppointmentDetails,
          },
          {
            key: "close",
            icon: "close",
          },
        ];
        break;
      case menuNamesEnum.THIRD_STEP_CHECKOUT:
        menuItems = [
          {
            key: menuNamesEnum.THIRD_STEP_CHECKOUT,
            name: window.APP.LANGUAGE.Pages.AppointmentCheckout.Name,
            // action : nil // this menu dont have action and will just act as an indicator;
          },
          {
            key: "print",
            icon: "print",
            action: this.printAppointmentDetails,
          },
          {
            key: "close",
            icon: "close",
          },
        ];
        break;
      case menuNamesEnum.INTERMEDIATE_STEP_BOOKING_ONLY_CUSTOMER_PROFILE:
      case menuNamesEnum.INTERMEDIATE_STEP_CUSTOMER_NOTES:
      case menuNamesEnum.INTERMEDIATE_STEP_CUSTOMER_PROFILE_CREATE:
      case menuNamesEnum.INTERMEDIATE_STEP_CUSTOMER_PROFILE_EDIT:
      case menuNamesEnum.INTERMEDIATE_STEP_CUSTOMER_RECENT_APPOINTMENTS:
        menuItems = [
          {
            key: menuNamesEnum.INTERMEDIATE_STEP_BOOKING_ONLY_CUSTOMER_PROFILE,
            name: window.APP.LANGUAGE.Pages.CustomerProfile.NameData,
            classes:
              limitedPermissions.canEditCustomerProfile &&
              currentMenu !=
                menuNamesEnum.INTERMEDIATE_STEP_BOOKING_ONLY_CUSTOMER_PROFILE
                ? "hidden"
                : "",
            action: this.dispatchCurrentMenu.bind(
              this,
              menuNamesEnum.INTERMEDIATE_STEP_BOOKING_ONLY_CUSTOMER_PROFILE
            ),
          },
          {
            key: menuNamesEnum.INTERMEDIATE_STEP_CUSTOMER_PROFILE_CREATE,
            name: window.APP.LANGUAGE.Pages.CustomerProfile.Name,
            classes:
              !limitedPermissions.canEditCustomerProfile ||
              currentMenu ==
                menuNamesEnum.INTERMEDIATE_STEP_BOOKING_ONLY_CUSTOMER_PROFILE
                ? "hidden"
                : "",
            action: this.dispatchCurrentMenu.bind(
              this,
              menuNamesEnum.INTERMEDIATE_STEP_CUSTOMER_PROFILE_CREATE
            ),
          },
          {
            key: menuNamesEnum.INTERMEDIATE_STEP_CUSTOMER_NOTES,
            name: window.APP.LANGUAGE.Pages.CustomerNotes.Name,
            classes:
              appointmentStepData.selectedCustomer.id &&
              !deleted &&
              limitedPermissions.canViewCustomerProfile
                ? "tab"
                : "tab disabled",
            action: this.goAwayFromCustomerPage.bind(
              this,
              menuNamesEnum.INTERMEDIATE_STEP_CUSTOMER_NOTES
            ),
          },
          {
            key: menuNamesEnum.INTERMEDIATE_STEP_CUSTOMER_RECENT_APPOINTMENTS,
            name: window.APP.LANGUAGE.Pages.CustomerRecentAppointment.Name,
            classes:
              appointmentStepData.selectedCustomer.id &&
              !deleted &&
              limitedPermissions.canViewCustomerProfile
                ? "tab"
                : "tab disabled",
            action: this.goAwayFromCustomerPage.bind(
              this,
              menuNamesEnum.INTERMEDIATE_STEP_CUSTOMER_RECENT_APPOINTMENTS
            ),
          },
          {
            key: "go-back",
            classes: "tab go-back",
            action: this.goAwayFromCustomerPage.bind(
              this,
              menuNamesEnum.FIRST_STEP_APPOINTMENT
            ),
            element: goBackElement,
          },
        ];
        break;
      default:
        menuItems = [];
    }
    return menuItems;
  };

  goAwayFromCustomerPage = (locationToGoTo) => {
    let {
      currentMenu,
      bookingOnlyCustomerProfileData,
      customerProfileData,
    } = this.props;
    if (
      currentMenu ==
      menuNamesEnum.INTERMEDIATE_STEP_BOOKING_ONLY_CUSTOMER_PROFILE
    ) {
      let savedSnapshot = sessionStorage.getItem(
        "BOOKING_ONLY_CUSTOMER_PROFILE_SNAPSHOT"
      );
      let currentSnapshot = JSON.stringify(bookingOnlyCustomerProfileData);
      if (
        currentMenu !=
          menuNamesEnum.INTERMEDIATE_STEP_BOOKING_ONLY_CUSTOMER_PROFILE ||
        savedSnapshot == currentSnapshot
      ) {
        this.dispatchCurrentMenu(locationToGoTo);
      } else {
        let visible = true;
        this.props.dispatch(
          updateGoBackFromBookingOnlyCustomerPageModalVisibility(visible)
        );
        this.props.dispatch(
          updateWhereToGoFromCustomerPageModal(locationToGoTo)
        );
      }
    } else {
      let savedSnapshot = sessionStorage.getItem(
        "CUSTOMER_PROFILE_DATA_SNAPSHOT"
      );
      let currentSnapshot = JSON.stringify(customerProfileData);

      if (
        (currentMenu !=
          menuNamesEnum.INTERMEDIATE_STEP_CUSTOMER_PROFILE_CREATE &&
          currentMenu !=
            menuNamesEnum.INTERMEDIATE_STEP_CUSTOMER_PROFILE_EDIT) ||
        savedSnapshot == currentSnapshot
      ) {
        this.dispatchCurrentMenu(locationToGoTo);
      } else {
        // Best comment
        let visible = true;
        this.props.dispatch(
          updateGoBackFromCustomerPageModalVisibility(visible)
        );
        this.props.dispatch(
          updateWhereToGoFromCustomerPageModal(locationToGoTo)
        );
      }
    }
  };

  handleCloseApp = () => {
    let { advancedAppointmentStepData, appointmentStepData } = this.props;
    let { recurringToggleOn } = advancedAppointmentStepData;
    let {
      triggerSaveForThisBookingSinceTheUserDragAndDroppedBookingFormInNewSlot,
    } = appointmentStepData;
    let {
      currentBookingId,
      advancedAppointmentStepDataFromLastSave,
      isMultiServiceAppointment,
    } = this.props;
    let savedSnapshot = sessionStorage.getItem("BOOKING_APPOINTMENT_SNAPSHOT");
    let currentSnapshot = JSON.stringify({
      appointmentStepData,
      advancedAppointmentStepData,
    });

    if (savedSnapshot == currentSnapshot) {
      //if there are no changes, no need to show the modal
      this.closeApp();
    } else {
      if (
        advancedAppointmentStepDataFromLastSave.recurringToggleOn &&
        currentBookingId
      ) {
        //this popup should only be visible whe modifying an existing recurring appointment
        let visibleRecursiveAppointmentModal = true;
        let closeAppWhenRecursiveAppointmentModalCloses = true;

        this.props.dispatch(
          updateRecurringAppointmentConfirmationModalVisibility(
            visibleRecursiveAppointmentModal,
            closeAppWhenRecursiveAppointmentModalCloses
          )
        );
      } else if (
        isMultiServiceAppointment &&
        currentBookingId &&
        triggerSaveForThisBookingSinceTheUserDragAndDroppedBookingFormInNewSlot
      ) {
        let visibleMultiServiceAppointmentModal = true;
        let closeAppWhenMultiserviceModalCloses = true;
        dispatch(
          updateMultiServiceAppointmentConfirmationModalVisibility(
            visibleMultiServiceAppointmentModal,
            closeAppWhenMultiserviceModalCloses
          )
        );
      } else {
        let visibleCloseAppointmentModal = true;
        this.props.dispatch(
          updateCloseAppointmentModalVisibility(visibleCloseAppointmentModal)
        );
      }
    }
  };

  closeApp = () => {
    let event = new CustomEvent("messageFromUsToParent", {
      detail: {
        action: "close",
      },
    });
    window.dispatchEvent(event);
  };

  printBooking = () => {
    let { currentBookingId } = this.props;
    //this.props.dispatch(getBookingPrintableVersion(currentBookingId));
    window.open(
      `${window.APP.apiPath}bookingload.action?calendarentryid=${currentBookingId}`,
      "_blank"
    );
  };

  handleCloseCheckout = () => {
    const { invoiceData, checkoutAppointmentStepData } = this.props;
    if (!invoiceData.key) {
      this.handleCloseApp();
    } else {
      if (
        invoiceData.status == "PAID" ||
        invoiceData.balanceamount > 0 ||
        checkoutAppointmentStepData.didDoRefund
      ) {
        this.closeApp();
      } else {
        this.props.dispatch(updateCloseAppointmentModalVisibility(true));
      }
    }
  };

  render() {
    let {
      currentMenu,
      currentBookingId,
      storeCardForLaterModalVisible,
      bookingCustomerProfileModalVisible,
    } = this.props;
    let menuItems = this.getMenuItems();

    let renderItemChild = (item) => {
      if (item.icon && !item.element) {
        return (
          <button type="button" className={item.icon + "_button2"}></button>
        );
      } else if (!item.element) {
        return item.name;
      } else {
        return item.element;
      }
    };

    return (
      <div className="booking-header">
        <div className="drag-handler"></div>
        <RestoreAppointmentModal />
        <CancelAppointmentModal />
        <CancelRecurringAppointmentModal />
        <CloseAppointmentModal />
        <SaveRecursiveAppointmentConfirmationModal />
        <GoBackFromCustomerPageModal />
        <GoBackFromBookingOnlyCustomerPageModal />
        {storeCardForLaterModalVisible ? <StoreCardForLaterModal /> : ""}
        {bookingCustomerProfileModalVisible ? (
          <BookingCustomerProfileModal />
        ) : (
          ""
        )}
        <MultiServiceAppointmentConfirmationModal />
        <div>
          {menuItems.map((item) => {
            if (
              item.key ==
                menuNamesEnum.INTERMEDIATE_STEP_CUSTOMER_PROFILE_CREATE &&
              currentMenu ==
                menuNamesEnum.INTERMEDIATE_STEP_CUSTOMER_PROFILE_EDIT
            ) {
              item.key = menuNamesEnum.INTERMEDIATE_STEP_CUSTOMER_PROFILE_EDIT;
            }

            if (currentMenu == menuNamesEnum.THIRD_STEP_CHECKOUT) {
              if (item.icon && !item.element) {
                if (item.icon == "close") {
                  return (
                    <button
                      key={item.key}
                      type="button"
                      onClick={this.handleCloseCheckout}
                      className="close_button2"
                    ></button>
                  );
                } else if (item.icon == "print") {
                  return (
                    <button
                      key={item.key}
                      type="button"
                      className="print_button2 hidden"
                    ></button>
                  );
                }
              } else {
                return (
                  <div
                    key={item.key}
                    data-active={item.key == currentMenu}
                    className={(item.classes || " tab ") + " " + item.key}
                  >
                    <a
                      className={` ${
                        item.key == currentMenu ? "active disabled" : ""
                      } disabled`}
                    >
                      {" "}
                      {renderItemChild(item)}
                    </a>
                  </div>
                );
              }
            } else {
              if (item.icon && !item.element) {
                if (item.icon == "close") {
                  return (
                    <button
                      key={item.key}
                      type="button"
                      onClick={this.handleCloseApp}
                      className="close_button2"
                    ></button>
                  );
                } else if (item.icon == "print") {
                  return (
                    <button
                      key={item.key}
                      onClick={this.printBooking}
                      type="button"
                      className={`print_button2 ${
                        currentBookingId
                          ? "print-button-on"
                          : "disabled-insensitive"
                      }`}
                    ></button>
                  );
                }
              } else {
                return (
                  <div
                    key={item.key}
                    data-active={item.key == currentMenu}
                    className={(item.classes || " tab ") + " " + item.key}
                  >
                    <a
                      onClick={item.action}
                      className={` ${
                        item.key == currentMenu ? "active disabled" : ""
                      } `}
                    >
                      {" "}
                      {renderItemChild(item)}
                    </a>
                  </div>
                );
              }
            }
          })}
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    currentMenu: state.menuReducer.currentMenu,
    appointmentStepData: state.appointmentStepReducer.appointmentStepData,
    savingBooking: state.bookingReducer.savingBooking,
    storeCardForLaterModalVisible:
      state.menuReducer.storeCardForLaterModalVisible,
    isMultiServiceAppointment: state.bookingReducer.isMultiServiceAppointment,
    bookingOnlyCustomerProfileData:
      state.customerProfileReducer.bookingOnlyCustomerProfileData,
    customerProfileData: state.customerProfileReducer.customerProfileData,
    limitedPermissions: state.appointmentStepReducer.limitedPermissions,
    advancedAppointmentStepDataFromLastSave:
      state.advancedAppointmentStepReducer
        .advancedAppointmentStepDataFromLastSave,
    currentBookingId: state.bookingReducer.currentBookingId,
    advancedAppointmentStepData:
      state.advancedAppointmentStepReducer.advancedAppointmentStepData,
    invoiceData: state.appointmentCheckoutReducer.invoiceData,
    checkoutAppointmentStepData:
      state.appointmentCheckoutReducer.checkoutAppointmentStepData,
    bookingCustomerProfileModalVisible:
      state.menuReducer.bookingCustomerProfileModalVisible,
  };
}
